import React, { useEffect, useState } from 'react';
import { Step, Steps, useSteps } from 'chakra-ui-steps';
import { Box, Heading } from '@chakra-ui/react';

const PoolRankingStepFunctionProgress = ({ status }) => {
  const { nextStep, prevStep, setStep, reset, activeStep } = useSteps({
    initialStep: 0,
  });
  const STEPS = [
    { label: 'Initiated' },
    { label: 'In progress' },
    { label: 'Completed' },
  ];

  const [state, setState] = useState('');
  const [steps, setSteps] = useState(STEPS);

  useEffect(() => {
    initialStepAndState(status);
  }, [status]);

  const initialStepAndState = (status) => {
    if (status === 'PENDING') {
      stepChangeHandler(0, 'Initiated', '');
    } else if (status === 'RUNNING') {
      stepChangeHandler(1, 'In progress', 'loading');
    } else if (status === 'SUCCEEDED') {
      stepChangeHandler(3, 'In progress', '');
    } else if (status === 'FAILED') {
      stepChangeHandler(1, 'Failed', 'error');
    } else if (status === 'TIMED_OUT') {
      stepChangeHandler(1, 'Timed out', 'error');
    } else if (status === 'ABORTED') {
      stepChangeHandler(1, 'Aborted', 'error');
    } else if (status === 'QUEUED') {
      stepChangeHandler(1, 'Queued', 'loading');
    }
    console.log(status);
    console.log(state);
    console.log(steps);
  };

  const stepChangeHandler = (stepNumber, stepName, state) => {
    const newStep = steps.map((step, index) => {
      if (index === 1) {
        return { ...step, label: stepName };
      }
      return step;
    });
    setStep(stepNumber);
    setSteps(newStep);
    setState(state);
  };

  return (
    <Box mb="10">
      <Heading as="h4" size="md" mb="4">
        Pool Ranking
      </Heading>
      <Steps colorScheme="whatsapp" activeStep={activeStep}>
        {steps.map(({ label }) => (
          <Step label={label} key={label} state={state}></Step>
        ))}
      </Steps>
    </Box>
  );
};
export default PoolRankingStepFunctionProgress;
